import { supabase } from "../../shared/data/supabaseClient";
import { toFriendlyError } from "../../shared/utils/helpers";

const PRELAUNCH_BYPASS_FUNCTION = "prelaunch-bypass";

function normalizeValue(value) {
  return String(value || "").trim();
}

function toPrelaunchBypassError(error, fallbackMessage) {
  const friendlyError = toFriendlyError(error, fallbackMessage);
  const message = normalizeValue(friendlyError?.message).toLowerCase();

  if (message.includes("too many") || message.includes("rate limit")) {
    return new Error("Too many incorrect password attempts. Try again in a few minutes.");
  }

  if (
    message.includes("non-2xx") ||
    message.includes("invalid") ||
    message.includes("unauthorized") ||
    message.includes("forbidden")
  ) {
    return new Error("Incorrect password");
  }

  return friendlyError;
}

function toPrelaunchGrantError(error, fallbackMessage) {
  const friendlyError = toFriendlyError(error, fallbackMessage);
  const message = normalizeValue(friendlyError?.message).toLowerCase();

  if (
    message.includes("non-2xx") ||
    message.includes("invalid") ||
    message.includes("expired") ||
    message.includes("unauthorized") ||
    message.includes("forbidden")
  ) {
    return new Error("Reviewer access expired.");
  }

  return friendlyError;
}

export async function unlockPrelaunchBypass(secret) {
  try {
    const { data, error } = await supabase.functions.invoke(
      PRELAUNCH_BYPASS_FUNCTION,
      {
        body: {
          secret: normalizeValue(secret),
        },
      },
    );
    if (error) throw error;

    const grant = normalizeValue(data?.grant);
    if (!data?.ok || !grant) {
      throw new Error("Reviewer access could not be unlocked.");
    }

    return {
      grant,
      expiresAt: normalizeValue(data?.expiresAt) || null,
    };
  } catch (error) {
    throw toPrelaunchBypassError(
      error,
      "Unable to unlock reviewer access.",
    );
  }
}

export async function validatePrelaunchBypassGrant(grant) {
  try {
    const { data, error } = await supabase.functions.invoke(
      PRELAUNCH_BYPASS_FUNCTION,
      {
        body: {
          grant: normalizeValue(grant),
        },
      },
    );
    if (error) throw error;
    if (!data?.ok) {
      throw new Error("Reviewer access expired.");
    }

    return {
      expiresAt: normalizeValue(data?.expiresAt) || null,
    };
  } catch (error) {
    throw toPrelaunchGrantError(error, "Reviewer access expired.");
  }
}
